import { Component, Injector } from '@angular/core';
import { RouterHelperService, CustomInjector } from '@evorait/pace-core';

@Component({
    selector: 'pace-authors-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
})
export class AppComponent {
    public title = 'pace-forms-for-authors';
    public constructor(
        private readonly injector: Injector,
        private readonly routerHelper: RouterHelperService,
    ) {
        // Make injector statically available for access in domain models, where angular does not provide a DI mechanism
        CustomInjector.setInjector(this.injector);
        this.routerHelper.subscribeToEvents();
    }
}
